module.exports = __webpack_public_path__ + "img/isanon.59deba91.svg";